// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ac1ad00e","239":"0075b64d","455":"9aba34e6"}[chunkId] + ".chunk.js";
};